import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'

export default (config = {}) => {
  let swiper
  const copies = []

  return {
    paused: false,

    init() {
      if (config.slider?.autoplay && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

      const element = this.$refs.swiper
      const wrapper = element.querySelector('.swiper-wrapper')
      const slides = [...wrapper.children]
      if (!slides.length) return

      if (config.duplicateSlides && config.slider?.loop) {
        const setWidth = slides.reduce((width, slide) => width + slide.getBoundingClientRect().width, 0)
        const targetWidth = 2 * Math.max(element.clientWidth, window.screen.width) + 2 * slides[0].getBoundingClientRect().width
        // Repeat complete sets before Swiper starts so short logo lists can loop.
        for (let width = setWidth; setWidth > 0 && width < targetWidth; width += setWidth) {
          slides.forEach(slide => {
            const copy = slide.cloneNode(true)
            copy.setAttribute('aria-hidden', 'true')
            copy.inert = true
            wrapper.append(copy)
            copies.push(copy)
          })
        }
      }

      swiper = new Swiper(element, {
        modules: [config.slider?.autoplay && Autoplay].filter(Boolean),
        ...config.slider,
      })
    },

    toggleAutoplay() {
      if (!swiper?.autoplay) return
      this.paused = !this.paused
      if (this.paused) {
        const translate = swiper.getTranslate()
        swiper.autoplay.stop()
        swiper.setTranslate(translate)
        swiper.setTransition(0)
        swiper.animating = false
      } else {
        swiper.autoplay.start()
      }
    },

    destroy() {
      swiper?.destroy()
      copies.forEach(copy => copy.remove())
    },
  }
}
